export type RangeValue =
  | { type: "minimum"; low: number }
  | { type: "maximum"; high: number }
  | { type: "between"; low: number; high: number };

export const getRangeBounds = (range: RangeValue | undefined) => {
  if (!range) {
    return { low: undefined, high: undefined };
  }
  switch (range.type) {
    case "minimum":
      return { low: range.low, high: undefined };
    case "maximum":
      return { low: undefined, high: range.high };
    case "between":
      return { low: range.low, high: range.high };
  }
};

export const rangesEqual = (
  left: RangeValue | undefined,
  right: RangeValue | undefined,
) => {
  if (!left || !right) {
    return left === right;
  }

  if (left.type !== right.type) {
    return false;
  }

  const leftBounds = getRangeBounds(left);
  const rightBounds = getRangeBounds(right);

  return (
    leftBounds.low === rightBounds.low && leftBounds.high === rightBounds.high
  );
};
